import { PlanLimitDialog } from './PlanLimitDialog';
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { CommandPalette } from './CommandPalette';
import { KeyboardShortcutsOverlay } from './KeyboardShortcuts';
import { SupportButton } from './SupportButton';
import { ImpersonationBanner, PendingDeletionBanner } from './shell/Banners';
import { Sidebar } from './shell/Sidebar';
import { Topbar } from './shell/Topbar';
import { MobileDrawer } from './shell/MobileDrawer';
import './shell/Shell.css';

/** Workspace shell: banners, sidebar (or mobile drawer), topbar, page, global chrome. */
export function Layout() {
    const [menuOpen, setMenuOpen] = useState(false);
    const { pathname } = useLocation();

    // Close the drawer on navigation (including Back/Forward).
    useEffect(() => { setMenuOpen(false); }, [pathname]);

    return (
        <div className="app-shell shell">
            <a className="shell-skip-link" href="#main-content">Skip to content</a>
            <ImpersonationBanner />
            <PendingDeletionBanner />
            <div className="shell-body">
                <Sidebar />
                <div className="shell-main">
                    <Topbar menuOpen={menuOpen} onOpenMenu={() => setMenuOpen(true)} />
                    <main id="main-content" className="main-content" tabIndex={-1}>
                        <Outlet />
                    </main>
                </div>
            </div>
            <MobileDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />
            <CommandPalette />
            <KeyboardShortcutsOverlay />
            <SupportButton />
            <PlanLimitDialog />
        </div>
    );
}
